import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";

import Row from "antd/es/row";
import CashDetailsColumn from "./CashDetailsColumn";

const CashDetails = ({
  transactionRecord,
  symbol,
  getFixedTwoDecimalValue,
}) => {
  const getTransactionType = (obj) => {
    let type = "Collected";
    if (obj.transaction_type === 1) {
      type = "Refund";
    } else if (obj.transaction_type === 2) {
      type = "Change";
    }
    return type;
  };
  const sortAscByTimeSlots = (unsortedArray, key = null) => {
    const sortedArray = [...unsortedArray];
    sortedArray.sort((item1, item2) => {
        const first = item1[key];
        const second = item2[key];

        if (first > second) {
        return 1;
        }
        return -1;
    });
    return sortedArray;
    };
  const getRateBreakdownDetails = (currentRecord) => {
    const arr = [];
    if (
      currentRecord &&
      currentRecord.acceptorHistoryData &&
      currentRecord.acceptorHistoryData.length > 0
    ) {
      currentRecord.acceptorHistoryData.forEach((acceptor) => {
        arr.push({ type: "Collected", amount: acceptor.amount, ts: acceptor.ts });
      });
    }
    if (
      currentRecord &&
      currentRecord.dispenserHistoryData &&
      currentRecord.dispenserHistoryData.length > 0
    ) {
      currentRecord.dispenserHistoryData.forEach((dispenser) => {
        arr.push({
          type: getTransactionType(dispenser),
          amount: dispenser.amount,
          ts: dispenser.ts,
        });
      });
    }
    if (arr && arr.length > 0) {
      const newArr = sortAscByTimeSlots(arr, "ts");
      return newArr;
    }
    return arr;
  };

  const getTotalAmountsObj = (currentRecord) => {
    if (
      currentRecord &&
      currentRecord.cashPageDetails &&
      currentRecord.cashPageDetails.length > 0
    ) {
      return {
        total_room_amount: currentRecord.cashPageDetails[0].total_room_amount || "",
        total_deposite_amount: currentRecord.cashPageDetails[0].total_deposite_amount || "",
        total_misc_amount: currentRecord.cashPageDetails[0].total_misc_amount || "",
        total_amount: currentRecord.cashPageDetails[0].total_amount || "",
        total_parking_amount: currentRecord.cashPageDetails[0].total_parking_amount || "",
        pending_amount: currentRecord.cashPageDetails[0].pending_amount || "",
        disclosure_amount: currentRecord.cashPageDetails[0].disclosure_amount || "",
      };
    }
    return {
      total_room_amount: "",
      total_deposite_amount: "",
      total_misc_amount: "",
      total_parking_amount: "",
      total_amount: "",
      pending_amount: "",
      disclosure_amount: "",
    };
  };

  const rateBreakDownDetails = getRateBreakdownDetails(transactionRecord);
  const totalAmountsObj = getTotalAmountsObj(transactionRecord);

  return (
    <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
        <Row type="flex" justify="space-between">
        <Col style={{ paddingTop: "5px" }}>
            <Badge
            overflowCount={9999999}
            count={"Cash Details"}
            className="details-badge"
            />
        </Col>
        </Row>
      <CashDetailsColumn
        label={
          transactionRecord.cashPageDetails[0].order_status === "2"
            ? "Total Refund Amount"
            : "Total Room Amount"
        }
        value={
          totalAmountsObj.total_room_amount
            ? `${symbol}${getFixedTwoDecimalValue(totalAmountsObj.total_room_amount)}`
            : "-"
        }
      />

      <CashDetailsColumn
        label={
          transactionRecord.cashPageDetails[0].order_status === "2"
            ? "Total Deposit Refund"
            : "Total Deposit Amount"
        }
        value={
          totalAmountsObj.total_deposite_amount
            ? `${symbol}${getFixedTwoDecimalValue(totalAmountsObj.total_deposite_amount)}`
            : "-"
        }
      />

      <CashDetailsColumn
        label={
          transactionRecord.cashPageDetails[0].order_status === "2"
            ? "Total Misc Refund"
            : "Total Misc Amount"
        }
        value={
          totalAmountsObj.total_misc_amount
            ? `${symbol}${getFixedTwoDecimalValue(totalAmountsObj.total_misc_amount)}`
            : "-"
        }
      />

      <CashDetailsColumn
        label={
          transactionRecord.cashPageDetails[0].order_status === "2"
            ? "Total Parking Refund"
            : "Total Parking Amount"
        }
        value={
          totalAmountsObj.total_parking_amount
            ? `${symbol}${getFixedTwoDecimalValue(totalAmountsObj.total_parking_amount)}`
            : "-"
        }
      />
      {transactionRecord.cashPageDetails[0].order_status === "1" &&
        transactionRecord?.operationData[0]?.selected_disclosures?.length > 0 && (
          <CashDetailsColumn
            label={"Total Disclosure Amount"}
            value={
              totalAmountsObj.disclosure_amount
                ? `${symbol}${getFixedTwoDecimalValue(totalAmountsObj.disclosure_amount)}`
                : "-"
            }
          />
        )}

      <CashDetailsColumn
        label={
          transactionRecord.cashPageDetails[0].order_status === "2"
            ? "Total Refund Amount"
            : "Total Amount"
        }
        value={
          totalAmountsObj.total_amount
            ? `${symbol}${getFixedTwoDecimalValue(totalAmountsObj.total_amount)}`
            : "-"
        }
      />

      {rateBreakDownDetails &&
        rateBreakDownDetails.length > 0 &&
        rateBreakDownDetails.map((obj, index) => (
          <CashDetailsColumn
            key={String(index)}
            label={obj.type}
            value={obj.amount ? `${symbol}${obj.amount}` : "-"}
          />
        ))}

      <CashDetailsColumn
        label={
          transactionRecord.cashPageDetails[0].order_status === "2"
            ? "Total Refund Remaining"
            : "Total Balance Remaining"
        }
        value={
          totalAmountsObj.pending_amount
            ? `${symbol}${getFixedTwoDecimalValue(totalAmountsObj.pending_amount)}`
            : "-"
        }
      />
    </Card>
  );
};

CashDetails.propTypes = {
  transactionRecord: PropTypes.object.isRequired,
  symbol: PropTypes.string.isRequired,
};

export default CashDetails;
